//
// Action types
//

export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

//
// Action creators
//

export function showAlert(alert) {
  return {
    type: SHOW_ALERT,
    alert
  };
}

export function hideAlert() {
  return {
    type: HIDE_ALERT
  };
}

function showAlertHandler(state, alert) {
  return { ...alert };
}

function hideAlertHandler() {
  return null;
}

//
// Reducer and handlers
//
export default function alertsReducer(state, action) {
  switch (action && action.type) {
    case SHOW_ALERT:
      return showAlertHandler(state, action.alert);

    case HIDE_ALERT:
      return hideAlertHandler();

    default:
      return state || null;
  }
}
